import uniqBy from 'lodash/uniqBy';
import themeService from '@/services/themeService';
import { mapGetters } from 'vuex';

export default {
  props: {
    chartData: {
      type: Array,
      default: () => ([]),
    },
    itemsUniqueProperty: {
      type: String,
      default: 'name',
    },
  },
  data: () => ({
    chartsRefs: [],
    hiddenLegends: [],
  }),
  computed: {
    ...mapGetters([
      'isPrinting',
    ]),
    legend() {
      const result = uniqBy(this.chartData, this.itemsUniqueProperty);
      return result;
    },
    fontColor() {
      return this.isPrinting
        ? themeService.getStyleVar('color-gray-medium-dark')
        : themeService.getFontColor();
    },
  },
  methods: {
    changeLegend(data) {
      const legends = Object.entries(data.selected);
      const hiddenLegends = legends.filter(legend => !legend[1]);
      this.hiddenLegends = hiddenLegends.map(item => item[0]);
    },
    toggleLegend(item) {
      (this.chartsRefs || []).forEach((ref) => {
        this.$refs[ref].dispatchAction({
          type: 'legendToggleSelect',
          name: item[this.itemsUniqueProperty],
        });
      });
    },
    selectAllLegends() {
      (this.chartsRefs || []).forEach((ref) => {
        this.$refs[ref].dispatchAction({
          type: 'legendAllSelect',
        });
      });
      this.hiddenLegends = [];
    },
    unselectAllLegends() {
      (this.chartsRefs || []).forEach((ref) => {
        this.$refs[ref].dispatchAction({
          type: 'legendAllSelect',
        });
        this.$refs[ref].dispatchAction({
          type: 'legendInverseSelect',
        });
      });
      this.hiddenLegends = this.legend.map(item => item[this.itemsUniqueProperty]);
    },
  },
};
